"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { AspectRatio } from "@/components/ui/aspect-ratio";
type Photo = {
  id: number;
  src: string;
  srcset?: string;
  alt: string;
  caption: string;
};
const kitchenPhotos: Photo[] = [{
  id: 1,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/IMG_7555.jpg",
  srcset: "https://gn-construction.com/wp-content/uploads/2026/09/IMG_7555.jpg-wvc-srcset",
  alt: "Finished bathroom remodel in Redlands with glass walk-in shower and double vanity",
  caption: "Bathroom remodel"
}, {
  id: 2,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/IMG_7539.jpg",
  srcset: "https://gn-construction.com/wp-content/uploads/2026/09/IMG_7539.jpg-wvc-srcset",
  alt: "Finished bathroom remodel in Redlands with lighted mirror and wood double vanity",
  caption: "Bathroom remodel"
}, {
  id: 3,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-redlands-bathroom-remodel-after-3-1024x768.jpg",
  alt: "Finished walk-in shower with matte black fixtures in Redlands",
  caption: "Bathroom remodel"
}, {
  id: 4,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-bathroom-remodel-after-1-1024x577.jpg",
  alt: "Finished bathroom remodel in Riverside with white vanity and framed mirrors",
  caption: "Bathroom remodel"
}, {
  id: 5,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-bathroom-remodel-after-3-1024x576.jpg",
  alt: "Finished glass shower with gray tile in Riverside",
  caption: "Bathroom remodel"
}, {
  id: 6,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-riverside-bathroom-remodel-after-4-1024x576.jpg",
  alt: "Finished bathroom remodel in Riverside with white vanity",
  caption: "Bathroom remodel"
}, {
  id: 7,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-redlands-primary-suite-remodel-after-3-1024x577.jpg",
  alt: "Finished primary bathroom in Redlands with checkerboard tile floor and walk-in shower",
  caption: "Primary suite bathroom"
}, {
  id: 8,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-redlands-primary-suite-remodel-after-4-577x1024.jpg",
  alt: "Finished primary bathroom in Redlands with dark wood vanity and checkerboard floor",
  caption: "Primary suite bathroom"
}, {
  id: 9,
  src: "https://gn-construction.com/wp-content/uploads/2026/09/gnc-redlands-primary-suite-remodel-after-5-577x1024.jpg",
  alt: "Finished primary bathroom in Redlands with dark wood vanity and glass shower",
  caption: "Primary suite bathroom"
}];
export default function KitchenGallery() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="kitchengallery" data-nav="light" className="bg-background text-foreground py-16 md:py-20 lg:py-24 border-b border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-10 lg:mb-14">
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">Finished projects</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold tracking-tight text-foreground mb-4">
            Completed bathrooms
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground font-sans leading-relaxed">
            Finished bathrooms from our projects in Redlands and Riverside.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {kitchenPhotos.map((photo, i) => <motion.figure key={photo.id} data-index={i} initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: shouldReduceMotion ? 0 : i % 3 * 0.08
        }} className="relative overflow-hidden rounded-xl border border-border shadow-xs bg-muted m-0">
              <AspectRatio ratio={4 / 3} className="w-full">
                <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" alt={photo.alt} loading="lazy" decoding="async" className="h-full w-full object-cover object-center" />
              </AspectRatio>
              <figcaption className="absolute left-3 bottom-3 rounded-md bg-background/90 px-2.5 py-1 text-xs font-medium text-foreground shadow-sm">
                {photo.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}